var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-message"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('img',{staticClass:"d-none d-md-block",attrs:{"src":require("@/assets/element_bulle.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }